export function getDotPosition({ max = 0, min = 0, value, height }) {
	const range = Math.abs(max - min);
	const relativeValue = value - min;

	const top = height - (relativeValue / range) * height;

	return top;
}
